import { forwardRef } from 'react'

import { isFirstDigitsAmex } from '../../utils/validation'
import { ArcadeHelpTextComponentProps } from '../Input/ArcadeHelpText'
import FormattedInput, { BaseFormattedInputProps } from '../Input/FormattedInput'

export interface CardSecurityCodeInputProps extends BaseFormattedInputProps, ArcadeHelpTextComponentProps {
  cardValue: string
}

/**
 * A formatted input for credit/debit card security codes (CVV).
 *
 * @example
 * ```tsx
 * <FieldLabel label="CVV">
 *   <CardSecurityCodeInput
 *     value={value}
 *     onChange={setValue}
 *     placeholder="123"
 *   />
 * </FieldLabel>
 * ```
 */
export const CardSecurityCodeInput = forwardRef<HTMLInputElement, CardSecurityCodeInputProps>(
  ({ cardValue, value, ...props }, ref) => {
    const isAmex = isFirstDigitsAmex(cardValue)
    const template = isAmex ? '#'.repeat(4) : '#'.repeat(3)

    return (
      <FormattedInput
        placeholder={template}
        value={value}
        {...props}
        autoComplete="cc-csc"
        ref={ref}
        template={template}
      />
    )
  }
)

export default CardSecurityCodeInput
